module.exports = __webpack_public_path__ + "img/shop-banner.d874918b.png";